<template>
  <v-autocomplete
    v-model="selectRelatorio"
    :items="relatoriosList"
    item-text="title"
    item-value="id"
    label="Pesquisar relatório"
    outlined
    dense
    clearable
    @change="$emit('onChange', selectRelatorio)"
    hide-details
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title> Nenhum relatório encontrado </v-list-item-title>
      </v-list-item>
    </template>

    <template v-slot:item="{ item }">
      <div class="border">
        <relatorio-card :relatorio="item"></relatorio-card>
      </div>
    </template>
  </v-autocomplete>
</template>
<script>
import RelatorioCard from "./relatorioCard.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    RelatorioCard,
  },
  props: {
    relatorios: [],
  },
  computed: {
    ...mapGetters(["isSala", "isAT", "isParceiro"]),

    relatoriosList() {
      return this.relatorios
        .filter((item) => {
          if (item.exibirEm && item.exibirEm.length > 0) {
            if (item.exibirEm.some((item) => this[item])) {
              return true;
            }

            return false;
          }
          return true;
        })
        .map((item) => ({
          id: item.id,
          title: item.title,
        }));
    },
  },
  watch: {
    "$route.params.relatorioRoute"(val) {
      this.getRelatorioSelected(val);
    },
  },
  methods: {
    getRelatorioSelected(val) {
      this.selectRelatorio = val
        ? this.relatorios.filter((item) => item.id == val)[0].id
        : null;
    },
  },
  data() {
    return {
      selectRelatorio: null,
    };
  },
  mounted() {
    this.getRelatorioSelected(this.$route.params.relatorioRoute);
  },
};
</script>
<style lang="scss" scoped>
.border {
  border: thin solid rgba(0, 0, 0, 0.12);
  width: 100%;
}
</style>
